import { ProjectStatus } from '../../types/enum/project-status';

export const projectStatusViewValue = (projectStatus: ProjectStatus): string =>
  projectStatus === 'approved' ? '承認済み' : '未承認';
